<script>
import options from './StafetDonationStepTwo.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-donation-step-two kb-optimizely-forms"
  >
    <component
      :is="componentName"
      :labels="labels"
      :nextStepCallback="nextStepCallback"
      :previousStepCallback="previousStepCallback"
      :displayInputError="displayInputError"
      :submitCallback="submitCallback"
      :stafetId="stafetId"
      :userData="userData"
    />
  </article>
</template>
